"use client";

import { Button } from "@repo/design-system/components/ui/button";
import { fonts } from "@repo/design-system/lib/fonts";
import { captureException } from "@sentry/nextjs";
import type NextError from "next/error";
import { useEffect } from "react";

interface GlobalErrorProperties {
  readonly error: NextError & { digest?: string };
  readonly reset: () => void;
}

const GlobalError = ({ error, reset }: GlobalErrorProperties) => {
  useEffect(() => {
    // Enhanced error logging for React error #130 (undefined component)
    const errorObj = error as unknown as Error & { digest?: string };
    const errorMessage =
      "message" in errorObj ? String(errorObj.message) : String(error);
    const _errorStack =
      "stack" in errorObj ? String(errorObj.stack) : undefined;
    const _errorName = "name" in errorObj ? String(errorObj.name) : undefined;

    // Check if this is React error #130
    if (error.digest?.includes("130") || errorMessage.includes("130")) {
    }

    captureException(error);
  }, [error]);

  return (
    <html className={fonts} lang="en">
      <body>
        <h1>Oops, something went wrong</h1>
        {error.digest?.includes("130") && (
          <p style={{ color: "red", margin: "1rem 0" }}>
            React Error #130: A component is undefined. Check the browser
            console for details.
          </p>
        )}
        <Button onClick={() => reset()}>Try again</Button>
      </body>
    </html>
  );
};

export default GlobalError;
